import React, { useEffect, useState } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ERouteLinks } from 'models/route';
import { ActionTypes } from 'state/actions/alert';
import { Alert } from 'components/atoms/Alert';
import { useAlert } from 'models/alertContext';
import { Box } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { EDictionaryTypes } from 'models/dictionary';
import { useLang } from 'models/langContext';
import { ILicenceTemplateFormValues } from 'models/licenceConfigurator';
import { useConfigurationLicence } from '../hooks';
import { FormLicenceTemplatePage } from '../FormLicenceTemplatePage';
import { initialFormValues } from '../helper';

const AddLicenceTemplatePage = () => {
  const { clearAlert, samePageAlert } = useAlert();
  const { t } = useTranslations();
  const [formValues, setFormValues] = useState<ILicenceTemplateFormValues>();
  const { selectedLanguage } = useLang();
  const { loadDictionaries, weaponLicenceGoodReason } = useConfigurationLicence();

  useEffect(() => {
    if (!formValues && weaponLicenceGoodReason?.length) {
      const goodReasonDictionaryIds = weaponLicenceGoodReason.reduce(
        (acc, item) => {
          acc[item.uniqueId.toString()] = false;
          return acc;
        },
        {} as Record<string, boolean>,
      );

      setFormValues({
        ...initialFormValues,
        conditions: {
          ...initialFormValues.conditions,
          goodReasonDictionaryIds,
        },
      });
    }
  }, [weaponLicenceGoodReason]);

  useEffect(() => {
    (async function init() {
      await loadDictionaries([
        EDictionaryTypes.weaponLicenceCategory,
        EDictionaryTypes.weaponLicenceCompetency,
        EDictionaryTypes.weaponLicenceGoodReason,
      ]);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage]);

  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_SAME_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <>
      <Breadcrumbs
        items={[
          {
            label: t('module.administration.name'),
            route: ERouteLinks.Administration,
          },
          {
            label: t('licenceConfiguration.header'),
            route: ERouteLinks.LicenceConfigurationPage,
          },
          t('licenceConfiguration.add.header'),
        ]}
      />
      <StyledPageTitle variant="h4">{t('licenceConfiguration.add.header')}</StyledPageTitle>

      {samePageAlert && (
        <Box sx={{ mt: 2 }}>
          <Alert text={samePageAlert.text} variant={samePageAlert.variant} />
        </Box>
      )}
      {formValues && <FormLicenceTemplatePage initialFormValues={formValues} />}
    </>
  );
};

export { AddLicenceTemplatePage };
